import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import renderUtils from "../../../helpers/renderUtils";
import MachineFormConfig from "./MachineFormConfig";
import {Category} from "./Category";
import CardForm from "../../../components/form/CardForm";
import {FormatPart} from "./FormatPart";
import {hasPackagingLinesFullAccess} from "../../../helpers/jwt";
import { useTranslation } from 'react-i18next';

export function Machine(props) {
    const { t } = useTranslation();
    const [canOpenCategories, setCanOpenCategories] = useState(props.machine.formatPartsCategories.length > 0)

    const [toggle, setToggle] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState();
    const [initialized, setInitialized] = useState(false);
    const [formatPartsReady, setFormatPartsReady] = useState(false);


    function isSameCategory(first, second) {
        if (!first || !second) {
            return false;
        }

        return first.category.id === second.category.id
    }

    function onToggle(val) {
        setToggle(val)
        if (props.onToggle && props.machine.formatPartsCategories.length > 0) {
            props.onToggle(val)
        }
    }

    function reInit() {
        setInitialized(false)
    }

    function initialize() {
        if (!initialized) {
            setInitialized(true)
        }
    }

    function selectCategory(category) {
        setFormatPartsReady(false)
        setSelectedCategory(category)
    }

    function categorySelected() {
        if (!!selectedCategory) {
            setFormatPartsReady(true)
        }
    }


    useEffect(initialize, [initialized])
    useEffect(categorySelected, [selectedCategory])

    return <>
        {initialized &&
            <Row>
                <CardForm
                    title={renderUtils.renderMachineType(props.machine, t)}
                    setLoader={props.setLoader}
                    fields={MachineFormConfig}
                    width={props.width || 4}
                    qrCodeValue={props.machine.id}
                    initialData={props.machine}
                    editable={props.editable !== false}
                    readOnly={props.readOnly}
                    api={"machine/" + props.machine.id}
                    withToggle={props.withToggle !== false}
                    disableCleanAfterSave={true}
                    reInit={reInit}
                    onToggleChange={onToggle}
                    performReload={() => props.setReload(!props.reload)}
                    hideIfNull={true}
                />
                {toggle && canOpenCategories && !props.withoutParts &&
                    <Col md={4}>
                        {
                            props.machine.formatPartsCategories.map(item =>

                                <Category categoryItem={item}
                                          active={isSameCategory(selectedCategory, item)}
                                          onClick={() => {
                                              if (isSameCategory(selectedCategory, item)) {
                                                  selectCategory(undefined)
                                              } else {
                                                  selectCategory(item)
                                              }
                                          }}
                                />)


                        }

                    </Col>
                }
                {toggle && !canOpenCategories &&
                    <Col md={4} className={"mt-2"}>
                        {<span >{t("common.no_category")}</span>}


                    </Col>
                }

                {toggle && formatPartsReady && selectedCategory &&
                    <Col md={4}>
                        {
                            selectedCategory.formatParts.map(part => <FormatPart
                                category={selectedCategory.category}
                                reload={props.reload}
                                setLoader={props.setLoader}
                                editable={false}
                                readOnly={true}
                                setReload={props.setReload}
                                reloadLine={props.reloadLine}
                                formatPart={part}/>)
                        }
                    </Col>
                }
            </Row>
        }
    </>;
}